import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Flex, Row } from 'antd';
import { ERoutesCommon } from 'common/models/routesModel';

export const EmptyRewardListPlaceholder: React.FC = () => {
  return (
    <Row justify="center">
      <Col xs={24} sm={16} md={12} lg={8}>
        <Flex vertical>
          <span className="fs-sm font-weight-7 color-grayDark">New rewards are coming soon!</span>
          <span className="t-align-c">Your points are secure — please check back later for new choices.</span>
          <Link className="link fs-xs" to={ERoutesCommon.Root}>
            Go to Menu
          </Link>
        </Flex>
      </Col>
    </Row>
  );
};
